const button = document.querySelectorAll('[data-dropdown]');
const content = document.querySelectorAll('.header__nav-sub');

if (window.innerWidth < 1024) {
  button.forEach((btn, index) => {
    const target = content[index];
    if (!btn || !target) return;
    btn.addEventListener('click', event => {
      event.preventDefault();
      target.classList.toggle('opened');
    });
  });
}

const button2 = document.querySelectorAll('.js-dropdown');
const content2 = document.querySelectorAll('.js-dropdownBody');

button2.forEach((btn2, index) => {
  const target2 = content2[index];
  if (!btn2 || !target2) return;
  btn2.addEventListener('click', event => {
    event.preventDefault();

    if (btn2.classList.contains('is_open')) {
      btn2.classList.remove('is_open');
      slideUp(target2, 500);
    } else {
      btn2.classList.add('is_open');
      slideDown(target2, 500);
    }
  });
});

// slideUp
const slideUp = (el, duration = 300) => {
  el.style.height = el.offsetHeight + "px";
  el.offsetHeight;
  el.style.transitionProperty = "height, margin, padding";
  el.style.transitionDuration = duration + "ms";
  el.style.transitionTimingFunction = "ease";
  el.style.overflow = "hidden";
  el.style.height = 0;
  el.style.paddingTop = 0;
  el.style.paddingBottom = 0;
  el.style.marginTop = 0;
  el.style.marginBottom = 0;
  setTimeout(() => {
    el.style.display = "none";
    el.style.removeProperty("height");
    el.style.removeProperty("padding-top");
    el.style.removeProperty("padding-bottom");
    el.style.removeProperty("margin-top");
    el.style.removeProperty("margin-bottom");
    el.style.removeProperty("overflow");
    el.style.removeProperty("transition-duration");
    el.style.removeProperty("transition-property");
    el.style.removeProperty("transition-timing-function");
  }, duration);
};

// slideDown
const slideDown = (el, duration = 300) => {
  el.style.removeProperty("display");
  let display = window.getComputedStyle(el).display;
  if (display === "none") {
    display = "block";
  }
  el.style.display = display;
  let height = el.offsetHeight;
  el.style.height = 0;
  el.style.paddingTop = 0;
  el.style.paddingBottom = 0;
  el.style.marginTop = 0;
  el.style.marginBottom = 0;
  el.offsetHeight;
  el.style.transitionProperty = "height, margin, padding";
  el.style.transitionDuration = duration + "ms";
  el.style.transitionTimingFunction = "ease";
  el.style.overflow = "hidden";
  el.style.height = height + "px";
  el.style.removeProperty("padding-top");
  el.style.removeProperty("padding-bottom");
  el.style.removeProperty("margin-top");
  el.style.removeProperty("margin-bottom");
  setTimeout(() => {
    el.style.removeProperty("height");
    el.style.removeProperty("overflow");
    el.style.removeProperty("transition-duration");
    el.style.removeProperty("transition-property");
    el.style.removeProperty("transition-timing-function");
  }, duration);
};

document.addEventListener('DOMContentLoaded', () => {
  const mq = window.matchMedia('(max-width: 768px)');
  const navList = document.querySelector('.header-navList');
  if (!navList) return;

  const getItemByLabel = label =>
    navList.querySelector(`[data-label="${label}"]`);

  const originalOrder = [...navList.children];

  const reorderNavForSP = () => {
    if (mq.matches) {
      const order = [
        '医院紹介',
        'ドクター紹介',
        '症例',
        '料金案内',
        'アクセス',
        '院内ツアー',
        'キャンセルポリシー',
        '診療案内',
        'NEWS',
        '医院コラム',
        'COLUMN',
        'CONTACT'
      ];

      order.forEach(label => {
        const item = getItemByLabel(label);
        if (item) navList.appendChild(item);
      });
    } else {
      // PCに戻ったら元の順に戻す
      originalOrder.forEach(item => navList.appendChild(item));
    }
  };

  reorderNavForSP();
  mq.addEventListener('change', reorderNavForSP);
});
